import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { PaymentController } from '../../controllers';
import { Spinner, Table, Card, Grid, Button } from '../reusable';
import { initialDate, lastDate, withdrawTableHeaeder } from '../../utils/Utils';
import { StyledWallet, StyledWalletTable, StyledWalletButtons } from './Styles';
import { RouterActions } from '../../redux/actions';
import { Colors } from '../../constants/Colors';
import TransferModal from '../wallet/TransferModal';
import { captureException } from '@sentry/minimal';
import moment from 'moment';

const Wallet = props => {
  const { saveHistoryOnRedux, setCurrentNav, history } = props;

  const {
    getSubscriptions,
    getFinancialInfo,
    getAccountInfo,
    getInvoices,
    getTotalAmountToReceive,
    getCoparticipations,
    transferBalance
  } = props;

  const {
    account,
    currentMonthAmount,
    lastMonthAmount,
    valueToReceive,
    profile,
    financial: { balance, balanceInTransaction, canTransferInMonth }
  } = props;

  const [financialInfo, setFinancialInfo] = useState([]);
  const [isFetching, setFetching] = useState(true);
  const [modal, setModal] = useState(false);
  const [transferReturn, setTransferReturn] = useState('');
  const [success, setSuccess] = useState(undefined);

  const autoCloseModal = () =>
    setTimeout(() => {
      setTransferReturn('');
      setModal(false);
    }, 5000);

  const handleModal = (visible, message, success) => {
    setModal(visible);
    setTransferReturn(message);
    setSuccess(success);
    autoCloseModal();
  };

  const requestTransfer = async () => {
    try {
      setModal(true);
      transferBalance(profile?.id, balance)
        .then(async transferResponse => {
          handleModal(true, transferResponse.message, transferResponse.success);
          await getAccountInfo(profile.id);
          autoCloseModal();
        })
        .catch(err => {
          handleModal(true, err.message, err.success);
          captureException(err);
        });
    } catch (err) {
      handleModal(true, err.message, err.success);
      captureException(err);
    }
  };

  const fetching = async () => {
    try {
      saveHistoryOnRedux(history);
      setCurrentNav('Carteira');

      await getAccountInfo(profile.id);

      setFetching(true);

      await getSubscriptions(profile.id, initialDate, lastDate);
      await getInvoices(profile.id, initialDate, lastDate);
      await getCoparticipations(profile.id, initialDate, lastDate);
      await getTotalAmountToReceive(currentMonthAmount);
      const financialResponse = await getFinancialInfo();

      setFinancialInfo(financialResponse);

      setFetching(false);
    } catch (err) {
      console.log('Error no fetching data', err);
    }
  };

  useEffect(() => {
    fetching();
  }, []);

  return !isFetching ? (
    <StyledWallet>
      <Grid rows={1} columns={2}>
        <Card title={'Saldo em Conta'} value={balance.toFixed(2)} ammount />
        <Card tip title={`Saldo a Receber`} value={valueToReceive} ammount />
      </Grid>

      <StyledWalletButtons>
        <Grid rows={1} columns={4} customColumns={[0.5, 0.5, 0.5, 0.5]}>
          <Button
            backgroundColor={canTransferInMonth ? Colors.blue : Colors.fourth}
            color={canTransferInMonth ? Colors.fourth : Colors.gray1}
            title={'Transferir saldo para conta bancária'}
            func={() => requestTransfer()}
            disabled={!canTransferInMonth}
          ></Button>

          {!canTransferInMonth ? (
            <Button
              backgroundColor={Colors.primary}
              title={`Última transferência em ${moment(account.last_withdraw).format(
                'DD/MM/YYYY'
              )}`}
              disabled={true}
            />
          ) : (
            <div></div>
          )}
          <div></div>
          <div></div>
          {/* <Button title={'Gerar relatório financeiro do mês'} backgroundColor={Colors.primary} /> */}
        </Grid>
      </StyledWalletButtons>

      <Grid rows={1} columns={3}>
        <Card tip title={'Recebimentos este Mês'} value={currentMonthAmount} ammount />
        <Card tip title={'Recebimentos Mês Anterior'} value={lastMonthAmount} ammount />
        <Card tip title={'Dinheiro em Trânsito'} value={balanceInTransaction.toFixed(2)} ammount />
      </Grid>

      <StyledWalletTable>
        <Table headers={withdrawTableHeaeder} data={financialInfo} />
      </StyledWalletTable>
      <TransferModal
        onRequestOpenModal={() => setModal(true)}
        onRequestCloseModal={() => setModal(false)}
        modalVisible={modal}
        message={transferReturn}
        success={success}
      />
    </StyledWallet>
  ) : (
    <Spinner />
  );
};

const mapStateToProps = state => {
  const {
    user: { profile },
    payment: {
      month,
      financial,
      account,
      subscriptionsInfo: {
        totalAmount: subscriptionsAmount,
        lastMonthAmount: subscriptionLastMonthAmout
      },
      invoicesInfo: { totalAmount: invoicesAmount, lastMonthAmount: invoicesLastMonthAmout }
    }
  } = state;

  const currentMonthAmount = (subscriptionsAmount + invoicesAmount).toFixed(2);
  const lastMonthAmount = (subscriptionLastMonthAmout + invoicesLastMonthAmout).toFixed(2);
  const valueToReceive = (currentMonthAmount - financial.currentMonthReceived).toFixed(2);

  return {
    profile,
    month,
    currentMonthAmount,
    lastMonthAmount,
    account,
    financial,
    valueToReceive
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getFinancialInfo: (month, year) => dispatch(PaymentController.getFinancialInfo(month, year)),
    saveHistoryOnRedux: history => dispatch(RouterActions.saveHistory(history)),
    setCurrentNav: current => dispatch(RouterActions.setCurrentRoute(current)),
    getAccountInfo: therapistId => dispatch(PaymentController.fetchAndSaveAccountInfo(therapistId)),
    getTotalAmountToReceive: value => dispatch(PaymentController.getTotalAmountToReceive(value)),
    transferBalance: (id, balance) => dispatch(PaymentController.transferBalance(id, balance)),
    getSubscriptions: (therapistId, initialDate, finalDate) =>
      PaymentController.fetchAndSaveSubscriptions(therapistId, initialDate, finalDate)(dispatch),
    getInvoices: (therapistId, initialDate, finalDate) =>
      PaymentController.fetchAndSaveAppointmentsInfo(therapistId, initialDate, finalDate)(dispatch),
    getCoparticipations: (therapistId, initialDate, finalDate) =>
      dispatch(
        PaymentController.fetchAndSaveCoparticipationInvoicesInfo(
          therapistId,
          initialDate,
          finalDate
        )
      )
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Wallet));
